import { getCookie } from 'cookies-next';
import { Nullable } from '../../../interfaces';
import { KycIdentityOriginNamespace } from '../../../namespaces';
import { useCoallescedCoinId } from '../../coin/useCoallescedCoinId';
import { CoinIDType } from '@starsoft/common/enums/coinId';
import { CookiesKey } from '@starsoft/common/enums';

/**
 * Custom hook to get the user origin ID based on the coin ID.
 *
 * @returns {Nullable<string>} - The origin ID of the user, or null if not found.
 *
 * Example usage:
 * const originId = useUserOriginId();
 */
export function useUserOriginId(): Nullable<string> {
  // Get the coin ID using the custom hook
  const { coinId } = useCoallescedCoinId();
  const externalOriginId = getCookie(CookiesKey.OriginId);

  // Get the origin ID based on the coin ID
  const originId: Nullable<string> =
    KycIdentityOriginNamespace.getIdentityOriginIdByCoinId(
      coinId as CoinIDType,
    );

  // Return the origin ID
  return originId;
}
